const OrderStatus = {
  ORDER_INSERTED: 100,
  ORDER_SHORTID_INSERTED: 110,
  ORDER_ATLOCATION: 200,
  ORDER_RECEIVED: 201,
  ORDER_TIME_ESTIMATE: 202,
  ORDER_REMINDER_SET: 210,
  ORDER_REMINDER_ALERT: 211,
  ORDER_NOTIFICATION_CONFIRMED_SUPERVISOR: 231,
  ORDER_PRINT_ONLINE_ORDER_SLIPS: 240,
  ORDER_PRINT_ONLINE_ORDER_SLIPS_RESULT: 241,
  ORDER_REPRINT_ORDER_SLIP: 242,
  ORDER_SENT_TO_INVENTORY: 250,
  ORDER_PAYMENT_STARTED: 300,
  ORDER_PAYMENT_CONFIRMED: 301,
  ORDER_PAYMENT_REFUND: 302,
  ORDER_PAYMENT_CANCELLED: 303,
  ORDER_PAYMENT_EXTERNAL: 305,
  ORDER_PAYMENT_REMINDER: 306,
  ORDER_PAID_OFFLINE: 330,
  ORDER_RECEIPT_CREATED: 310,
  ORDER_INVOICE_CREATED: 320,
  ORDER_INVOICE_CREATE_ERROR: 321,
  ORDER_PREPARING: 400,
  ORDER_DONE: 401,
  ORDER_ITEM_INFO: 450,
  ORDER_ITEM_PREPARING: 451,
  ORDER_ITEM_DONE: 452,
  ORDER_ITEM_RECEIVEDBYCOSTUMER: 453,
  ORDER_ITEM_STORNO: 455,
  ORDER_VIP_PURCHASE_FINALIZED: 500,
  ORDER_RECEIVEDBYCOSTUMER: 600,
  ORDER_EXT_NUMBER_INSERTED: 700,
  ORDER_ADDITIONAL_INFO: 710,
  ORDER_FRUITSYS_FORWARD_SUCCESS: 750,
  ORDER_FRUITSYS_FORWARD_ERROR: 751,
  ORDER_FRUITSYS_FORWARD_STARTED: 755,
  ORDER_FRUITSYS_FORWARD_TRIGGERED: 752,
  ORDER_FRUITSYS_REQUEST_ORDER: 753,
  ORDER_ERROR_LOGGED: 800,
  ORDER_CLOSED_SUCCESS: 900,
  ORDER_CLOSED_FAIL: 901,
  ORDER_CLOSED_FAIL_SYS_PAYMENT_TIMEOUT: 902,
  ORDER_CLOSED_FAIL_CUSTOMER_CANCELLED: 903,
  ORDER_CLOSED_CANCEL_BASKET: 904
}

const DeliveryType = {
  PreOrder: 'preorder',
  TableOrder: 'tableorder',
  Delivery: 'delivery',
  Pickup: 'pickup',
}

const AddressType = {
  PROFILE_ADDRESS: 0,
  INVOICE_ADDRESS: 1,
  DELIVERY_ADDRESS: 2,
}

const DeviceType = {
  KIOSK: 1,
  ORDER_MANAGER: 2,
  POS: 3,
  ORDER_SCREEN: 4,
  SECOND_SCREEN: 5,
  ECR_POS: 6,
  MONITOR: 10,
  LOCAL_SERVER: 9999,
  BRAND_APP: 1000,
}

const PaymentType = {
  OFFLINE: 'Offline',
  ONLINE: 'Online'
}

const OrderStates = {
  BASKET: 0,
  UNCONFIRMED: 5,
  INSERTED: 10,
  SEEN: 20,
  SCHEDULED: 30,
  PENDING: 40,
  PREPARING: 50,
  DONE: 60,
  CLOSED_SUCCESS: 90,
  CLOSED_FAIL: 91
}

const OrderItemStates = {
  WAITING: 0,
  PREPARING: 50,
  DONE: 60,
  ATCUSTOMER: 90,
  STORNO: 91
}

const OrderStateNames = {
  [OrderStates.BASKET]: 'BASKET',
  [OrderStates.UNCONFIRMED]: 'UNCONFIRMED',
  [OrderStates.INSERTED]: 'INSERTED',
  [OrderStates.SEEN]: 'SEEN',
  [OrderStates.SCHEDULED]: 'SCHEDULED',
  [OrderStates.PENDING]: 'PENDING',
  [OrderStates.PREPARING]: 'PREPARING',
  [OrderStates.DONE]: 'DONE',
  [OrderStates.CLOSED_SUCCESS]: 'CLOSED_SUCCESS',
  [OrderStates.CLOSED_FAIL]: 'CLOSED_FAIL'
}

const DeviceTypes = {
  [1]: 'kiosk',
  [2]: 'orderManager',
  [3]: 'pos',
  [4]: 'orderScreen',
  [5]: 'secondScreen',
  [6]: 'ecrPos'
}

const DocumentTypes = {
  ShiftStart: 1,
  ShiftEnd: 2,
  Receipt: 10,
  ReceiptStorno: 11,
  PayIn: 20,
  PayOut: 21,
}

const DocumentSubTypes = {
  Receipt: {
    Normal: 0,
    Attraction: 1,
    Personnel: 2
  }
}

export { DeliveryType, OrderStatus, AddressType, DeviceType, OrderStates, OrderStateNames, PaymentType, OrderItemStates, DeviceTypes, DocumentTypes, DocumentSubTypes }
